export const parseCep = (cep) =>
  cep
    ?.match(/\d/g)
    ?.slice(0, 9)
    .map((c, i, l) => {
      if (i === 2) return "." + c;
      if (i === 5) return "-" + c;
      return c;
    })
    .join("");

export const parseCPF = (cpf) =>
  cpf
    ?.match(/\d/g)
    ?.slice(0, 11)
    .map((c, i) => {
      if (i === 3 || i === 6) return "." + c;
      if (i === 9) return "-" + c;
      return c;
    })
    .join("");

export const parseCNPJ = (cnpj) =>
  cnpj
    ?.match(/\d/g)
    ?.slice(0, 14)
    .map((c, i) => {
      if (i === 2 || i === 5) return "." + c;
      if (i === 8) return "/" + c;
      if (i === 12) return "-" + c;
      return c;
    })
    .join("");

// 99 3333 - 3333
export const parsePhoneNumber = (phone) => {
  try {
    if (phone.match(/\d/g).length <= 10) {
      return phone
        ?.match(/\d/g)
        .slice(0, 10)
        .map((c, i) => {
          if (i === 2) return " " + c;
          if (i === 6) return " - " + c;
          return c;
        })
        .join("");
    }
    return phone
      ?.match(/\d/g)
      ?.slice(0, 11)
      .map((c, i) => {
        if (i === 2) return " " + c;
        if (i === 7) return " - " + c;
        return c;
      })
      .join("");
  } catch (error) {}
};

export const parseTimestamp = (t) => {
  let ts = t.split("T");
  let d = ts[0].split("-");
  let h = ts[1].split(".");

  let data = d[2] + "/" + d[1] + "/" + d[0];
  let hora = h[0];

  return { data, hora, dataHora: data + " " + hora };
};

export const parseFontSizeContract = (c) => {
  return c.replaceAll(/(font-size:( )*[0-9]*px)/g, "font-size:20px");
};
